<template>
  <div class="main">
    <b-row>
      <b-col cols="9" v-loading="loading">
        <b-row>
          <div v-loading="loading" class="chart-form">
            <el-form ref="chartsForm" :inline="true" :model="chartsForm" style = "100%">
              <el-form-item label="Effective Date:">
                  <el-date-picker type="date" placeholder="Pick a date" value-format="yyyy-MM-dd" v-model="chartsForm.effectiveDate"
                  @change="chartDateChange" :clearable=false :picker-options="pickerOptions"></el-date-picker>
              </el-form-item>
              <el-form-item label="Top:" >
                <el-select v-model="chartsForm.topValue" placeholder=""  style = "width: 70px;">
                  <el-option v-for="item in chartsForm.topCount" :key="item" :label="item" :value="item"></el-option>
                </el-select>

              </el-form-item>
              <el-form-item label="Program Type:">
                <el-select v-model="chartsForm.programTypeValue" placeholder="select program type">
                  <el-option v-for="(key,value) in chartsForm.programType" :key="value" :label="key" :value="value"></el-option>
                </el-select>
              </el-form-item>
              <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="onRefresh">Refresh</el-button>
            </el-form>
          </div>
        </b-row>
        <b-row>
          <b-row>
            <b-col style="width:50px">
              <div id="earnings_frame1"></div>
            </b-col>
            <b-col style="width:50px">
              <div id="earnings_frame2"> </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="width:50px">
              <div id="earnings_frame3"> </div>
            </b-col>
            <b-col style="width:50px">
              <div id="earnings_frame4"> </div>
            </b-col>
          </b-row>
        </b-row>
      </b-col>
      <b-col cols="3" >
        <div v-loading="loading" class="report-form">
          <h4 style="text-align: center; color:#606266"> Run Report </h4>
          <el-form ref="reportsForm" :model="reportsForm" label-width="120px" label-position="top">
            <el-form-item >
              <!-- label="Select a Report:" -->
              <el-select v-model="reportsForm.report" placeholder="Select a Report" style = "width: 100%; padding-bottom: 10px">
                <el-option v-for="item in reportsForm.reports" :key="item.id" :label="item.reportName" :value="item.reportSearchPath">
              </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker type="date" placeholder="Pick a date" value-format="yyyy-MM-dd" v-model="reportsForm.reportDate" style = "width: 100%; padding-bottom: 10px"
                @change="reportDateChange" :clearable=false :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="reportsForm.programTypeValue">
                <div v-for="(key,value) in reportsForm.programType" :key="value">
                  <el-radio :label="value">{{key}}</el-radio> <br>
                </div>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c; margin:0 auto; display:block;" @click="onSubmit">Submit</el-button>
            </el-form-item>
          </el-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as pieChartUtil from '../utils/PieChartUtility.js';
import * as cognosLaunch from '../utils/cognoslaunch.js';
import * as dataUtil from '../utils/DataUtil.js';
import * as dateUtil from '../utils/DateUtil.js';
import HTTP_API from '@/utils/http-api'
import GRAPHICS_HTTP_API from '@/utils/graphics-http-api'

export default {
  data() {
    return {
      date: new Date(),
      lenderId:'',
      currencyCode: '',
      camPassport: '',
      loading: false,
      months: dateUtil.getMonthNames(),
      chartsForm: {
        defaultEffectiveDate: '',
        effectiveDate: '',
        topValue: 5,
        programTypeValue: 'B',
        topCount: [],
        programType: [],
        earliestDate: ''
      },
      reportsForm: {
        defaultReportDate: '',
        reportDate: '',
        report: "",
        reports: [],
        programTypeValue: 'B',
        programType: [],
        earliestDate: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    }
  },
  methods:{
    onSubmit() {
      console.log('submit!');
      console.log(this.reportsForm);
      var reportSearchPath = this.reportsForm.report
      var cam_passport = this.camPassport
      var begin_dt = this.reportsForm.reportDate
      var programType = this.reportsForm.programTypeValue
      var token = sessionStorage.getItem('web-token')
      if (token) {
        cognosLaunch.cognosLaunchInWindow(
          "reportWindow",
          "menubar=no,toolbar=no,status=yes,location=no,resizable=yes,toolbar=0,width=950,height=880,scrollbars=yes",
          "ui.gateway", process.env.VUE_APP_COGNOS_URL, "m_passportID",
          cam_passport, "ui.tool", "CognosViewer",
          "ui.action", "run", "ui.object",
          reportSearchPath, "ui", "h1",
          "p_Lender", this.lenderId, "p_begin_dt", begin_dt,
          "p_program_type", programType, "cv.toolbar",
          false, "cv.header", false
        );
      }else{
        cognosLaunch.logoffCognos();
        setTimeout(() => {
          window.location.href = "/CR/"
        }, 1000)
      }
    },
    onRefresh() {
      var vm = this
      console.log('refreshed!');
      console.log(vm.chartsForm);
      var token = sessionStorage.getItem('web-token')
      if (token) {
        if(vm.chartsForm.effectiveDate != null && vm.chartsForm.effectiveDate != ""){
          vm.getCharts()
        }
      }else{
        cognosLaunch.logoffCognos();
        setTimeout(() => {
          window.location.href = "/CR/"
        }, 1000)
      }
    },
    chartDateChange(inputDateStr){
      console.log("date change chart")
      console.log(inputDateStr)
      var vm = this
      var inputDate = null;
      if (inputDateStr != null){
        var inputArr = inputDateStr.split("-");
        inputDate = new Date(parseInt(inputArr[0], 10) , parseInt(inputArr[1], 10) - 1, inputArr[2]);
      }
      if (inputDate < vm.reportsForm.earliestDate) {
        this.$message({
          duration: 0,
          showClose: true,
          message: 'Invalid date selected.  Historical data is limited to the prior 12 months.\nPlease select a date on or after '
           + vm.months[vm.reportsForm.earliestDate.getMonth()] + ' ' + vm.reportsForm.earliestDate.getDate() + ', ' + vm.reportsForm.earliestDate.getFullYear()
          + '.\nIf you require data beyond this historical period, please contact your eSecLending Relationship Manager.'
        });
        vm.chartsForm.effectiveDate = vm.reportsForm.defaultReportDate;
      }
    },
    reportDateChange(inputDateStr){
      console.log("date change report")
      console.log(inputDateStr)
      var vm = this
      var inputDate = null;
      if (inputDateStr != null){
        var inputArr = inputDateStr.split("-");
        inputDate = new Date(parseInt(inputArr[0], 10) , parseInt(inputArr[1], 10) - 1, inputArr[2]);
      }
      if (inputDate < vm.reportsForm.earliestDate) {
        this.$message({
          duration: 0,
          showClose: true,
          message: 'Invalid date selected.  Historical data is limited to the prior 12 months.\nPlease select a date on or after '
           + vm.months[vm.reportsForm.earliestDate.getMonth()] + ' ' + vm.reportsForm.earliestDate.getDate() + ', ' + vm.reportsForm.earliestDate.getFullYear()
          + '.\nIf you require data beyond this historical period, please contact your eSecLending Relationship Manager.'
        });
        vm.reportsForm.reportDate = vm.reportsForm.defaultReportDate;
      }
    },
    getLoansData(){
      var vm = this
      vm.loading = true;
      HTTP_API.get('/earnings/earningsdashboard')
      .then(response => {
        vm.chartsForm.topCount = response.data.topCount
        vm.chartsForm.programType = response.data.programType
        vm.lenderId = response.data.lenderId
        vm.currencyCode = response.data.prefReportingCurr
        vm.camPassport = response.data.camPassport

        if(response.data.effectiveDate != null){
          vm.chartsForm.defaultEffectiveDate = response.data.effectiveDate.split("T")[0]
          vm.chartsForm.effectiveDate = response.data.effectiveDate.split("T")[0]
        }
        vm.reportsForm.programType = response.data.programType
        vm.reportsForm.reports = response.data.reports
        vm.reportsForm.report = response.data.reports[0].reportSearchPath
        var yesterday = new Date();
        yesterday.setDate(vm.date.getDate()-1)
        var day = yesterday.getDate();
        if (day < 10){
          day = '0' + day;
        }
        var month = yesterday.getMonth()+1
        if (month < 10){
          month = '0' + month;
        }
        var year = yesterday.getFullYear();
        vm.reportsForm.defaultReportDate = year + '-'+ month + '-'+ day;
        var monthNow =vm.date.getMonth()
        var yearNow = vm.date.getFullYear();
        var dayNow = vm.date.getDate();
        var dateNow = yearNow + '-'+ monthNow + '-'+ dayNow;
        var defaultReportArr = dateNow.split("-");
        vm.reportsForm.earliestDate = new Date(parseInt(defaultReportArr[0], 10) - 1, parseInt(defaultReportArr[1], 10) - 1, 1);
        vm.reportsForm.reportDate = year + '-'+ month + '-'+ day;
        if(vm.chartsForm.effectiveDate != null && vm.chartsForm.effectiveDate != ""){
          vm.getCharts()
        }
        vm.resetAllFlag();
      })
      .catch(function (error) {
        console.log(error.response)
        vm.resetAllFlag();
      })
    },
    getCharts(){
      var Highcharts = require('highcharts');
      require('highcharts/modules/exporting')(Highcharts);

      var localCurrencyCode = this.currencyCode

      var chartTemplate = {
        chart: {
          backgroundColor: "#FAFAFA",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          chartIndex: '',
          slices: []
        },
        credits: {
          enabled: false
        },
      yAxis: {
            title: {
              text: null
            },
            labels: {
                formatter: function () {
                    return dataUtil.getCurrencySymbol(localCurrencyCode) + " " + dataUtil.formatCurrency(this.value, 0);
                }
            }
        },
        navigation: {
          buttonOptions: {
            theme: {
              "stroke-width": 1,
              stroke: "silver",
              r: 0,
              states: {
                hover: {
                  fill: "#bada55",
                },
                select: {
                  stroke: "#039",
                  fill: "#bada55",
                },
              },
            },
          },
        },
        exporting: {
          buttons: {
            contextButton: {
              enabled: true,
            },
            barChartButton: {
              text: "Bar Chart",
              align: "center",
              y: 25,
              symbolFill: "#B5C9DF",
              hoverSymbolFill: "#779ABF",
              _titleKey: "Balance",
              onclick: function () {
                try {

                  var chartIndex = Number.parseInt(this.options.chartIndex)
                  var frameNumber = chartIndex + 1
                  var targetedFrame = "earnings_frame" + (frameNumber)
                  this.options.chart.type = "column";
                  this.options.series[0].data = this.options.chart.slices
                  Highcharts.chart(targetedFrame, this.options);
                } catch (error) {
                  console.log(error.response)
                }
              },
            },
            pieChartButton: {
              text: "Pie Chart",
              align: "center",
              y: 25,
              symbolFill: "#B5C9DF",
              hoverSymbolFill: "#779ABF",
              _titleKey: "Balance",
              onclick: function () {
                try {
                  var chartIndex = Number.parseInt(this.options.chartIndex)
                  var frameNumber = chartIndex + 1
                  var targetedFrame = "earnings_frame" + (frameNumber)
                  this.options.chart.type = "pie";
                  this.options.series[0].data = this.options.chart.slices
                  Highcharts.chart(targetedFrame, this.options);
                } catch (error) {
                  console.log(error.response)
                }
              },
            },
          },
        },
        title: {
          text: "On Loan Market Value By Country",
          style: {
      fontSize: '15px'
   }
        },
        graphIndex: 0,
        tooltip: {
        formatter: function () {
                    return "<b>" + this.point.name + "</b>: " +  dataUtil.getCurrencySymbol(localCurrencyCode) + " " + Math.round(this.y).toLocaleString("en-US");
                }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            size: 230,
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
              style: {
                color:
                  (Highcharts.theme && Highcharts.theme.contrastTextColor) ||
                  "black",
              },
            },
          },
        },
        series: [
          {
            colorByPoint: true,
            data: [],
            showInLegend: false
          },
        ],
        xAxis: {
          categories: [],
        },
        chartIndex: "",
      };

      var fundRecordset = {}
      var borrowerRecordset = {}
      var countryRecordset = {}
      var securityRecordset = {}

      var paramSet = {}
      paramSet.lenderId = this.lenderId;
      paramSet.currencyCode = this.currencyCode;
      paramSet.effectiveDateString = dateUtil.formatDateFromEightDigits(this.chartsForm.effectiveDate)
      paramSet.programType = this.chartsForm.programTypeValue
      paramSet.topCount = this.chartsForm.topValue

      GRAPHICS_HTTP_API.post('/earningtabpies',paramSet).then(response => {
      console.log(response.data)
      var retVal = response.data
      fundRecordset = retVal.fund
      borrowerRecordset = retVal.borrower
      countryRecordset = retVal.country
      securityRecordset = retVal.security

      }).catch(function (error) {
        console.log(error.response)})
        .finally(function(){
          var pie1 = Object.assign({}, chartTemplate)
          pie1.chartIndex = 0
          pie1.title.text = 'Total Earnings By Fund'
          var pieFilling1 = pieChartUtil.recordsetToPieFilling(fundRecordset, 'fundCode', 'totalOnLoanMarketValue')
          pie1.chart.slices = pieFilling1
          pie1.series[0].data = pieFilling1
          var pieColumnNames1 = pieChartUtil.parseColumnValues(
            fundRecordset,
            "fundCode"
          );
          pie1.xAxis.categories = pieColumnNames1;
          Highcharts.chart('earnings_frame1', pie1 );

          var pie2 = Object.assign({}, chartTemplate)
          pie2.chartIndex = 1
          pie2.title.text = 'Total Earnings By Borrower'
          var pieFilling2 = pieChartUtil.recordsetToPieFilling(borrowerRecordset, 'borrowerName', 'totalOnLoanMarketValue')
          pie2.chart.slices = pieFilling2
          pie2.series[0].data = pieFilling2

          var pieColumnNames2 = pieChartUtil.parseColumnValues(
            borrowerRecordset,
            "borrowerName"
          );
          pie2.xAxis.categories = pieColumnNames2;
          Highcharts.chart('earnings_frame2', pie2 );

          var pie3 = Object.assign({}, chartTemplate)
          pie3.chartIndex = 2
          pie3.title.text = 'Total Earnings By Country'
          var pieFilling3 = pieChartUtil.recordsetToPieFilling(countryRecordset, 'countryName', 'totalOnLoanMarketValue')
          pie3.chart.slices = pieFilling3
          pie3.series[0].data = pieFilling3;
          var pieColumnNames3 = pieChartUtil.parseColumnValues(
            countryRecordset,
            "countryName"
          );
          pie3.xAxis.categories = pieColumnNames3;
          Highcharts.chart('earnings_frame3', pie3);

          var pie4 = chartTemplate
          pie4.chartIndex = 3
          pie4.title.text = 'Total Earnings By Security (Discretionary only)'
				  var pieFilling4 = pieChartUtil.recordsetToPieFilling(securityRecordset, 'assetType', 'totalOnLoanMarketValue')
          pie4.chart.slices = pieFilling4
          pie4.series[0].data = pieFilling4
          var pieColumnNames4 = pieChartUtil.parseColumnValues(
            securityRecordset,
            "assetType"
          );
          pie4.xAxis.categories = pieColumnNames4;
          Highcharts.chart('earnings_frame4', pie4 );
          document.getElementById("earnings_frame1").classList.add('borderClass');
          document.getElementById("earnings_frame2").classList.add('borderClass');
          document.getElementById("earnings_frame3").classList.add('borderClass');
          document.getElementById("earnings_frame4").classList.add('borderClass');

      });
    },
    resetAllFlag() {
      this.loading = false
    }
  },
  created() {
    this.getLoansData()
  }
}
</script>

<style scoped>
  .report-form {
    border-radius: 5px;
    padding: 5px 5px 5px 5px;
    margin-top: 100px;
    /* background: rgba(255, 255, 255, .9); */
    background: #f2f2f2;
    opacity: 0.96;
    border: 2px solid #7cc1eb;
  }
  .chart-form {
    border-radius: 5px;
    margin-left: 7px;
    padding: 5px 5px 5px 5px;
    /* background: rgba(255, 255, 255, .9); */
    background: #f2f2f2;
    opacity: 0.96;
    border: 2px solid #7cc1eb;
    width: 875px;
  }
  .el-form-item {
    padding: 0;
    margin: 0;
  }
  .main{
  }
  /* #earnings_frame1, #earnings_frame2, #earnings_frame3, #earnings_frame4{
    margin: 12px 0px 5px 0px;
    border: 1.5px solid silver;
    box-shadow: 0 0 5px silver;
  } */
  .borderClass{
    margin: 12px 0px 5px 0px;
    border: 1.5px solid silver;
    box-shadow: 0 0 5px silver;
  }
</style>
